import {
  IconAdjustments,
  IconAlignBoxBottomCenter,
  IconBuildingBank,
  IconBuildingStore,
  IconClipboard,
  IconClipboardList,
  IconCoins,
  IconCreditCard,
  IconFileInvoice,
  IconFileText,
  IconKey,
  IconLayoutDashboard,
  IconListDetails,
  IconNote,
  IconPalette,
  IconQrcode,
  IconReceipt,
  IconReceipt2,
  IconRepeat,
  IconReplace,
  IconReport,
  IconSettings,
  IconSettings2,
  IconSettingsQuestion,
  IconUserCheck,
  IconUsers,
  IconWallet,
} from "@tabler/icons-react";

export interface NavigationItem {
  title: string;
  /** Overrides the top-header text when this item is the active section (sidebar still uses `title`). */
  headerTitle?: string;
  description?: string;
  icon: React.FC;
  color: string;
  link: string;
  disabled?: boolean;
  children?: NavigationItem[];
  parent?: NavigationItem;
  homeLink?: string;
  requiredPermission?: string;
  audience?: "PLATFORM" | "TENANT";
}

const navigationData: NavigationItem[] = [
  {
    description: "Партнерын бүртгэл, хяналт, гэрээний харилцаа болон супер админы эрх идэвхжүүлэх",
    title: "Партнер удирдлага",
    icon: IconAdjustments,
    color: "indigo",
    link: "/partner-management",
    homeLink: "partner",
    children: [
      {
        title: "Партнер жагсаалт",
        icon: IconListDetails,
        color: "indigo",
        link: "/partner-management/partner",
      },
      {
        title: "CP-Admin жагсаалт",
        icon: IconCoins,
        color: "indigo",
        link: "/partner-management/admin",
      },
      {
        title: "Хэрэглэгчдийн жагсаалт",
        icon: IconUsers,
        color: "indigo",
        link: "/partner-management/user",
      },
      {
        title: "Секторын лавлах",
        icon: IconAlignBoxBottomCenter,
        color: "indigo",
        link: "/partner-management/sector",
      },
      {
        title: "QPay мерчант",
        icon: IconQrcode,
        color: "indigo",
        link: "/partner-management/merchant",
      },
    ],
  },
  {
    description: "Хувийн мэдээллийн дэлгэрэнгүй",
    title: "Миний мэдээлэл тохиргоо",
    icon: IconSettings,
    color: "cyan",
    link: "/settings",
    disabled: true,
    children: [
      {
        title: "Миний мэдээлэл",
        icon: IconFileText,
        color: "indigo",
        link: "/settings/profile",
      },
    ],
  },
  {
    description: "ДЭП ХХК-ны систем хэрэглэгчийн бүртгэл, эрхийн тохиргоо, лог",
    title: "Системийн хэрэглэгчид",
    icon: IconUsers,
    color: "red",
    link: "/users",
    homeLink: "list",
    children: [
      {
        title: "Хэрэглэгчид",
        icon: IconUsers,
        color: "red",
        link: "/users/list",
      },
      {
        title: "Роль",
        icon: IconUserCheck,
        color: "red",
        link: "/users/role",
      },
      {
        title: "Эрхүүд",
        icon: IconKey,
        color: "red",
        link: "/users/permissions",
      },
    ],
  },
  {
    description: "Платформын хэмжээнд ашиглах лавлах мэдээллийн бүртгэл, тохиргоо",
    title: "Лавлах тохиргоо",
    icon: IconSettings2,
    color: "lime",
    link: "/reference",
    homeLink: "b2b-list",
    children: [
      {
        title: "Төлбөрийн нөхцөл",
        icon: IconCreditCard,
        color: "indigo",
        link: "/reference/b2b-list",
      },
      {
        title: "Барааны лавлах",
        icon: IconReport,
        color: "indigo",
        link: "/reference/product-list",
      },
    ],
    disabled: false,
  },
  {
    description: "Хэрэглэгчийн лог бүртгэл, мэйл сервис, SMS сервис болон интеграцитай холбоотой үйлдлийн бүртгэл",
    title: "Системийн лог",
    icon: IconNote,
    color: "orange",
    link: "/payment",
    children: [],
    disabled: true,
  },
  {
    description: "Ажилтнуудад зориулсан заавар, гарын авлага, асуулт хариултууд",
    title: "Асуулт хариулт, заавар",
    icon: IconSettingsQuestion,
    color: "grape",
    link: "/customer",
    disabled: true,
    children: [
      {
        title: "Анкор Корпорэйт",
        icon: IconClipboardList,
        color: "indigo",
        link: "/customer/anchor-corporate",
      },
      {
        title: "SME Onboarding",
        icon: IconClipboard,
        color: "indigo",
        link: "/customer/sme-onboarding",
      },
      {
        title: "Supplier рольтой",
        icon: IconRepeat,
        color: "indigo",
        link: "/customer/supplier-role",
      },
      {
        title: "Buyer рольтой",
        icon: IconReplace,
        color: "indigo",
        link: "/customer/buyer-role",
      },
      {
        title: "B2B Данс тохиргоо",
        icon: IconWallet,
        color: "indigo",
        link: "/customer/b2b-accounting",
      },
    ],
  },
  {
    description: "НӨАТ-н баримтын жагсаалт, хяналт удирдлага",
    title: "И-Баримт",
    icon: IconReceipt,
    color: "indigo",
    link: "/ebarimt",
    homeLink: "receipts",
    children: [
      {
        title: "Баримтын жагсаалт",
        icon: IconReceipt,
        color: "indigo",
        link: "/ebarimt/receipts",
      },
    ],
  },
  {
    description: "Платформын tenant бүртгэл, брэндинг, theme удирдлага",
    title: "Tenant удирдлага",
    icon: IconPalette,
    color: "violet",
    link: "/tenant",
    homeLink: "list",
    children: [
      {
        title: "Tenant жагсаалт",
        icon: IconListDetails,
        color: "violet",
        link: "/tenant/list",
      },
    ],
  },
  {
    description: "Платформ ↔ tenant болон tenant ↔ end-customer-ийн төлбөр, шимтгэлийн удирдлага",
    title: "Billing",
    icon: IconReceipt2,
    color: "teal",
    link: "/billing",
    homeLink: "tenants",
    requiredPermission: "BIL_001",
    children: [
      { title: "Тенантууд", icon: IconBuildingStore, color: "teal", link: "/billing/tenants", requiredPermission: "BIL_001" },
    ],
  },
  {
    description: "Өөрийн төлбөр, шимтгэлийн бодлого, нэхэмжлэх",
    title: "Төлбөр & шимтгэл",
    icon: IconReceipt2,
    color: "teal",
    link: "/my-billing",
    audience: "TENANT",
    children: [
      { title: "Дашбоард",          headerTitle: "Биллинг", icon: IconLayoutDashboard, color: "teal", link: "/my-billing" },
      { title: "Платформ төлбөр",   icon: IconFileInvoice,     color: "teal", link: "/my-billing/platform" },
      { title: "Шимтгэлийн бодлого", icon: IconReceipt2,        color: "teal", link: "/my-billing/fee-policy" },
      { title: "Данс",              icon: IconBuildingBank,    color: "teal", link: "/my-billing/accounts" },
      { title: "Харилцагчийн мэдээлэл", icon: IconUsers,        color: "teal", link: "/my-billing/customer-info" },
    ],
  },
];

const navigationDataMappedByLink = navigationData.reduce((acc, item) => {
  acc[item.link] = item;
  if (item.children) {
    item.children.forEach((child) => {
      acc[child.link] = {
        ...child,
        parent: item,
      };
    });
  }
  return acc;
}, {} as Record<string, NavigationItem>);

const navigationDataMappedByParentLink = navigationData.reduce((acc, item) => {
  if (item.children) {
    acc[item.link] = item.children;
  }
  return acc;
}, {} as Record<string, NavigationItem[]>);

export { navigationData, navigationDataMappedByLink, navigationDataMappedByParentLink };
